import Vue from 'vue'
import moment from 'moment'

const conf = require('../../config/index.js')
const env = process.env.NODE_ENV || 'alpha'

const state = {
  upload_file_app: null,
  file_license_import: null,
  file_license_resign: null,
  file_license_move: null,
}

const mutations = {
  UPLOAD_FILE(state, payload) {
    state.upload_file_app = payload
  },
  FILE_LICENSE_IMPORT(state, payload) {
    state.file_license_import = payload
  },
  FILE_LICENSE_RESIGN(state, payload) {
    state.file_license_resign = payload
  },
  FILE_LICENSE_MOVE(state, payload) {
    state.file_license_move = payload
  },
}

const actions = {
  //[API :: upload file application]
  api_upload_file_app({ commit }, data) {
    $('#modal-status-form').modal('hide')
    $('.modal').modal('hide')
    this._vm.$swal({
      title: 'กรุณารอสักครู่',
      html: '<h5 class="m-b-md">กำลังทำการอัปโหลดเอกสาร</h5><div class="loader"></div>',
      showConfirmButton: false,
      allowOutsideClick: false,
    })
    let formData = new FormData()
    formData.append('file', data.filename)
    Vue.http
      .post(
        conf[env].VUE_APP_PATH_API + 'upload-application-form/' + data.application_id,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
            'x-auth-from': this._vm.$session.get('chili').auth_from,
          },
        },
      )
      .then(
        response => {
          let res = response.body
          //console.log("== upload file ==", res);
          if (res.statusCode == 200) {
            //console.log("== SUCCESS upload file ==");
            let html
            if (data.backoffice == 'card_family' || data.backoffice == 'all_family') {
              html =
                '<h5>ท่านสามารถ UPLOAD ใบคำขอของสมาชิกครอบครัวท่านอื่นได้ โดยการกลับไปหน้าจัดการสมาชิกได้เลยค่ะ</h5>'
            } else {
              html =
                '<h5>ท่านสามารถสร้างใบคำขอลูกค้าอื่นเพิ่มเติมได้ โดยการกลับไปเมนูหลักได้เลยค่ะ</h5>'
            }
            this._vm
              .$swal({
                type: 'success',
                title: 'UPLOAD เอกสารเรียบร้อยแล้วค่ะ \nใบคำขอเอาประกันภ้ยนี้เสร็จสมบูรณ์',
                html: html,
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'OK',
              })
              .then(result => {
                if (result.value) {
                  if (data.backoffice == false) {
                    window.location.href = conf[env].VUE_APP_LOCATION + '/manage_app'
                  }
                  if (data.backoffice == true) {
                    window.location.href = conf[env].VUE_APP_LOCATION + '/tvi/issued'
                  }
                  if (data.backoffice == 'card_family' || data.backoffice == 'all_family') {
                    window.location.href =
                      conf[env].VUE_APP_LOCATION + '/insurance_family/' + data.family_id
                  }
                }
              })
            commit('UPLOAD_FILE', res.result)
          } else {
            //console.log("== Fail upload file");
            commit('UPLOAD_FILE', null)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD เอกสาร appllication',
            })
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error upload file");
            commit('UPLOAD_FILE', null)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD เอกสาร appllication',
            })
          }
        },
      )
  },
  api_upload_file_bill_app({ commit }, data) {
    $('#modal-status-form').modal('hide')
    let formData = new FormData()
    formData.append('file', data.filename)
    Vue.http
      .post(conf[env].VUE_APP_PATH_API + 'upload-payment-form/' + data.application_id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          let res = response.body
          //console.log("== upload file BILL ==", res);
          if (res.statusCode == 200) {
            //console.log("== SUCCESS upload file bill ==");
            //commit('UPLOAD_FILE_BILL', res.result)
            this._vm.$swal({
              type: 'success',
              title: 'UPLOAD เอกสาร Bill payment เรียบร้อย',
            })
          } else {
            //console.log("== Fail upload file bill");
            //commit('UPLOAD_FILE_BILL', null)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD เอกสาร billpay',
            })
          }
        },
        response => {
          let res = response.body
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error upload file bill");
            //commit('UPLOAD_FILE_BILL', null)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD เอกสาร billpay',
            })
          }
        },
      )
  },

  //[API :: upload file license]
  api_upload_file_import_user({ commit }, data) {
    let formData = new FormData()
    formData.append('file', data.filename)
    Vue.http
      .post(conf[env].VUE_APP_PATH_API + 'import-user', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          let res = response.body
          //console.log("== upload file license ==", res);
          if (res.statusCode == 200) {
            //console.log("== SUCCESS upload file license ==");
            commit('FILE_LICENSE_IMPORT', true)
            this._vm.$swal({
              type: 'success',
              title: 'UPLOAD FILE License เรียบร้อย',
            })
          } else {
            //console.log("== Fail upload file license");
            commit('FILE_LICENSE_IMPORT', false)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD FILE License',
            })
          }
        },
        response => {
          let res = response.body
          commit('FILE_LICENSE_IMPORT', false)
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error upload file");
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD FILE License',
            })
          }
        },
      )
  },
  api_upload_file_resign_user({ commit }, data) {
    let formData = new FormData()
    formData.append('file', data.filename)
    Vue.http
      .post(conf[env].VUE_APP_PATH_API + 'resign-user', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          let res = response.body
          //console.log("== upload file Resign ==", res);
          if (res.statusCode == 200) {
            //console.log("== SUCCESS upload file Resign ==")
            commit('FILE_LICENSE_RESIGN', true)
            this._vm.$swal({
              type: 'success',
              title: 'UPLOAD FILE Resign เรียบร้อย',
            })
          } else {
            //console.log("== Fail upload file Resign");
            commit('FILE_LICENSE_RESIGN', false)
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD FILE Resign',
            })
          }
        },
        response => {
          let res = response.body
          commit('FILE_LICENSE_RESIGN', false)
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error upload file");
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD FILE Resign',
            })
          }
        },
      )
  },
  api_upload_file_move_user({ commit }, data) {
    let formData = new FormData()
    formData.append('file', data.filename)
    Vue.http
      .post(conf[env].VUE_APP_PATH_API + 'move-user', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
      })
      .then(
        response => {
          let res = response.body
          //console.log("== upload file MOVE ==", res);
          if (res.statusCode == 200) {
            //console.log("== SUCCESS upload file MOVE ==");
            commit('FILE_LICENSE_MOVE', true)
            this._vm.$swal({
              type: 'success',
              title: 'UPLOAD FILE MOVE เรียบร้อย',
            })
          } else {
            commit('FILE_LICENSE_MOVE', false)
            //console.log("== Fail upload file MOVE");
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD FILE MOVE',
            })
          }
        },
        response => {
          let res = response.body
          commit('FILE_LICENSE_MOVE', false)
          if (res.statusCode == 401) {
            if (this._vm.$session.get('chili').auth_from == 'tmb') {
              var cookies = document.cookie.split(';')
              for (var i = 0; i < cookies.length; i++) {
                var equals = cookies[i].indexOf('=')
                var name = equals > -1 ? cookies[i].substr(0, equals) : cookies[i]
                document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
              }
              this._vm.$session.destroy()
              let url = conf[env].VUE_APP_TMB_LOGOUT_URL + conf[env].VUE_APP_LOCATION
              window.location.assign(url)
            } else {
              this._vm.$session.destroy()
              window.location.href = conf[env].VUE_APP_LOCATION
            }
          } else {
            //console.log("error upload file");
            this._vm.$swal({
              type: 'error',
              title: 'เกิดข้อผิดพลาดการ UPLOAD FILE MOVE',
            })
          }
        },
      )
  },

  //[API] GET file application
  api_get_file_bill_pay({ commit }, application_id) {
    Vue.http
      .get(conf[env].VUE_APP_PATH_API + 'bill-payment/' + application_id, {
        headers: {
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          let res = response.body
          //console.log("== get file BILL ==", res);
          //console.log("== SUCCESS get file bill ==");
          //commit('GET_FILE_BILL', res.result)
          let newBlob = new Blob([res], {
            type: 'application/pdf',
          })

          // IE doesn’t allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }

          const data = window.URL.createObjectURL(newBlob)
          let link = document.createElement('a')
          link.href = data
          link.download = 'billpay-' + application_id + '.pdf'
          link.click()

          setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data)
          }, 100)

          //commit('GET_FILE_BILL', null)
        },
        response => {
          let res = response.body
          //console.log("error upload file bill");
          $('.modal-print-insurance').modal('hide')
          //commit('GET_FILE_BILL', null)
          this._vm.$swal({
            type: 'error',
            title: 'เกิดข้อผิดพลาดการ print bill payment กรุณาลองใหม่อีกครั้ง',
          })
        },
      )
  },
  api_get_file_application({ commit }, application_id) {
    Vue.http
      .get(conf[env].VUE_APP_PATH_API + 'application-form/' + application_id, {
        headers: {
          Authorization: 'Bearer ' + this._vm.$session.get('chili').access_token,
          'x-auth-from': this._vm.$session.get('chili').auth_from,
        },
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          let res = response.body
          //console.log("== get file app ==", res);
          //console.log("== SUCCESS get file app ==");
          //commit('GET_FILE_BILL', res.result)
          let newBlob = new Blob([res], {
            type: 'application/pdf',
          })

          // IE doesn’t allow using a blob object directly as link href
          // instead it is necessary to use msSaveOrOpenBlob
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob)
            return
          }

          const data = window.URL.createObjectURL(newBlob)
          let link = document.createElement('a')
          link.href = data
          link.download = 'application-' + application_id + '.pdf'
          link.click()

          setTimeout(function() {
            // For Firefox it is necessary to delay revoking the ObjectURL
            window.URL.revokeObjectURL(data)
          }, 100)
        },
        response => {
          let res = response.body
          //console.log("error upload file bill");
          $('.modal-print-insurance').modal('hide')

          this._vm.$swal({
            type: 'error',
            title: 'เกิดข้อผิดพลาดการเปิดไฟล์ กรุณาลองใหม่อีกครั้ง',
          })
        },
      )
  },
}

const getters = {
  resUploadfileApp: state => state.upload_file_app,
  resFileLicenseImport: state => state.file_license_import,
  resFileLicenseResign: state => state.file_license_resign,
  resFileLicenseMove: state => state.file_license_move,
}

export default {
  state,
  getters,
  mutations,
  actions,
}
